<header class="point__header">
  @defer (on viewport) { 
    <img 
      [src]="point().img" 
      [attr.alt]="('Imagen' | translate) + ' ' + point().title"
      (error)="handleImgError($event)"
    >
  } @placeholder {
    <img 
      src="/assets/imgs/default-custom-route-img.webp" 
      [attr.alt]="('Imagen' | translate) + ' ' + point().title"
    >
  }
</header>